import {
   OPEN_COMPONENT_PROPS_PANEL,
   HIDE_COMPONENT_PROPS_PANEL,
   EXPAND_COMPONENT_PROPS_PANEL,
   COLLAPSE_COMPONENT_PROPS_PANEL,
   OPEN_COMPONENT_PROPS_CONFIRMATION_DIALOG,
   CLOSE_COMPONENT_PROPS_CONFIRMATION_DIALOG,
   SET_COMPONENT_PROPS_PANEL_FORM_ISDIRTY,
   SET_SELECTED_COMPONENT_PROPS_PANEL,
   SET_SELECTED_NODE,
   OPEN_START_NODE_PANEL,
   HIDE_START_NODE_PANEL,
   SET_MODEL_LAYOUT,
   SET_COMPONENT_PROPS_PANEL_TITLE,
   UPDATE_COMPONENT_PROPS_TAB,
   SET_RECENTLY_DELETED_BRANCH_NODE_ID
} from "redux/constants/flowDesigner";

export const showComponentPropsPanel = (payload) => ({
   type: OPEN_COMPONENT_PROPS_PANEL,
   payload
});
export const hideComponentPropsPanel = (payload) => ({
   type: HIDE_COMPONENT_PROPS_PANEL,
   payload
});
export const expandComponentPropsPanel = () => ({
   type: EXPAND_COMPONENT_PROPS_PANEL
});
export const collapseComponentPropsPanel = () => ({
   type: COLLAPSE_COMPONENT_PROPS_PANEL
});
export const showComponentPropsConfirmationDialog = () => ({
   type: OPEN_COMPONENT_PROPS_CONFIRMATION_DIALOG
});
export const closeComponentPropsConfirmationDialog = () => ({
   type: CLOSE_COMPONENT_PROPS_CONFIRMATION_DIALOG
});
export const setComponentPropsPanelFormIsDirty = (tabId, isDirty) => ({
   type: SET_COMPONENT_PROPS_PANEL_FORM_ISDIRTY,
   payload: { tabId, isDirty }
});
export const setSelectedComponentPropsPanel = (payload) => ({
   type: SET_SELECTED_COMPONENT_PROPS_PANEL,
   payload
});
export const setSelectedNode = (payload) => ({
   type: SET_SELECTED_NODE,
   payload
});
export const showStartNodePanel = () => ({
   type: OPEN_START_NODE_PANEL
});
export const hideStartNodePanel = () => ({
   type: HIDE_START_NODE_PANEL
});
export const setModelLayout = (layout) => ({
   type: SET_MODEL_LAYOUT,
   payload: layout
});
export const setComponentPropsPanelTitle = (tabId, title) => ({
   type: SET_COMPONENT_PROPS_PANEL_TITLE,
   payload: { tabId, title }
});
export const updateComponentPropsTab = (tabId, tabData) => ({
   type: UPDATE_COMPONENT_PROPS_TAB,
   payload: { tabId, tabData }
});
export const setRecentlyDeletedBranchNodeId = (branchNodeId) => ({
   type: SET_RECENTLY_DELETED_BRANCH_NODE_ID,
   payload: { branchNodeId }
});
